import _ from 'lodash'
import { withSnackbar } from 'notistack'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import BackIcon from '@material-ui/icons/ArrowBack'
import { useDeepEffect } from '../../utils/hooks'
import { styles } from './styles'
import Title from '../../components/Title'
import { Centered } from '../../components/HeroProduct/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import EditMaterial from './EditMaterial'
import AddMaterial from './AddMaterial'
import ListMaterial from './ListMaterial'
import { getMaterials } from '../../stores/material'
import { useDispatch, useSelector } from 'react-redux'
import { getHeroMe, saveHeroMaterial } from '../../stores/hero'

export const AccountProduct = (props) => {
  const {
    enqueueSnackbar,
    me,
    history: { goBack }
  } = props
  const dispatch = useDispatch()
  const [page, setPage] = useState('list')
  const [myProducts, setMyProducts] = useState([])
  const [productList, setProductList] = useState([])
  const { materials } = useSelector((state) => state.material)

  useDeepEffect(() => {
    async function fetchData() {
      await dispatch(getMaterials())
    }

    fetchData()
  }, [])

  useDeepEffect(() => {
    if (!_.isEmpty(materials)) {
      const dataOptions = materials.map((option) => {
        return {
          ...option,
          products: getProduct(option.materialList)
        }
      })
      setProductList(dataOptions)
    }
  }, [materials])

  function getProduct(materials) {
    const arr = []
    materials.forEach((material) => {
      me.products.forEach((product) => {
        if (material.id === product.material.id) {
          arr.push({
            ...product,
            minQuantity: product.minQuantity
          })
        }
      })
    })

    return arr
  }

  const onSaveMaterialProduct = async (body) => {
    await dispatch(saveHeroMaterial(body, enqueueSnackbar, me.id))
    await dispatch(getHeroMe())
  }

  function onChangePage(value) {
    if (value === 'add') {
      const dataOptions = materials.map((option) => {
        return {
          ...option,
          products: []
        }
      })

      setMyProducts(dataOptions)
      setPage('list')
    } else if (value === 'addMaterial') {
      setPage('edit')
    } else if (value === 'fromAdd') {
      setPage('add')
    }
    setPage(value)
  }

  async function onClickAdd() {
    const dataOptions = materials.map((option) => {
      return {
        ...option,
        products: getProduct(option.materialList)
      }
    })

    await setMyProducts(dataOptions)
    await setPage('add')
  }

  async function onClickEdit() {
    const dataOptions = materials.map((option) => {
      return {
        ...option,
        products: getProduct(option.materialList)
      }
    })

    await setMyProducts(dataOptions)
    await setPage('edit')
  }

  if (me) {
    return (
      <React.Fragment>
        <AppBar position="sticky">
          <Toolbar style={styles.toolbar}>
            <IconButton
              id="btnBack"
              color="inherit"
              aria-label="Menu"
              style={styles.menuButton}
              onClick={() => goBack()}>
              <BackIcon />
            </IconButton>
            <Typography
              id="titlePage"
              variant="h6"
              color="inherit"
              style={styles.grow}>
              วัสดุรีไซเคิลที่รับ
            </Typography>
            <IconButton style={{ width: '48px' }} />
          </Toolbar>
        </AppBar>
        <div style={{ marginTop: 10 }}>
          {page === 'list' && (
            <ListMaterial
              me={me}
              myProducts={productList}
              onClickAdd={onClickAdd}
              onClickEdit={onClickEdit}
            />
          )}
          {page === 'add' && (
            <div>
              <Title name="เลือกวัสดุรีไซเคิลที่จะรับ" />
              <AddMaterial
                me={me}
                materials={materials}
                onChangePage={onChangePage}
                myProducts={myProducts}
                setMyProducts={setMyProducts}
              />
            </div>
          )}
          {page === 'edit' && (
            <div>
              <Title name="เลือกวัสดุรีไซเคิลที่จะรับ" />
              <EditMaterial
                me={me}
                materials={materials}
                onChangePage={onChangePage}
                myProducts={myProducts}
                setMyProducts={setMyProducts}
                onSaveMaterialProduct={onSaveMaterialProduct}
              />
            </div>
          )}
        </div>
        {/* <Card elevation={isMobile ? 0 : 1} square style={{ minHeight: '80vh' }}> */}
        {/*  <CardContent style={{ marginBottom: '5%' }}> */}
        {/*    <HeroProduct me={me} setProductIdList={setProductIdList} productIdList={productIdList} /> */}
        {/*  </CardContent> */}
        {/*  <ButtonFixDiv> */}
        {/*    <Row justify="center"> */}
        {/*      <Button */}
        {/*        fullWidth */}
        {/*        variant="contained" */}
        {/*        color="primary" */}
        {/*        style={{ maxWidth: 350 }} */}
        {/*        onClick={(e) => onSaveMaterialProduct(e)} */}
        {/*      > */}
        {/*        บันทึก */}
        {/*      </Button> */}
        {/*    </Row> */}
        {/*  </ButtonFixDiv> */}
        {/* </Card> */}
      </React.Fragment>
    )
  } else {
    return (
      <Centered>
        <CircularProgress />
      </Centered>
    )
  }
}

AccountProduct.propTypes = {
  // data: PropTypes.object.isRequired,
  // me: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired
}

export default compose(withRouter, withSnackbar)(AccountProduct)



// WEBPACK FOOTER //
// ./src/pages/AccountProduct/index.js